import React from 'react';
import {useMediaQuery} from 'react-responsive';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ManageCardTouchPoints from './ManageCardTouchPoints';
import {replaceAssetsImgUrl} from 'cms/helpers/common';
import {MOBILE_WIDTH, TABLET_WIDTH} from 'helpers/stableValues';
import stoneImage from 'User/helpers/images/stone1.svg';
import lightYellowStone from 'images/manage-booking/lightYellowStone.svg';
import redSmallStone from 'images/manage-booking/redSmallStone.svg';
import lightRedStone from 'images/manage-booking/lightRedStone.svg';
import partyIcon from 'images/manage-booking/partyIcon.svg';
import Section from 'helpers/Section';
import LazyImage from 'helpers/LazyImage';

const ManageBookingTouchPoints = ({manageBooking, bgColor, touchPointClasses, touchPointStyle}) => {
  const isMobile = useMediaQuery({query: `(max-width: ${MOBILE_WIDTH}px)`});
  const isTablet = useMediaQuery({query: `(max-width: ${TABLET_WIDTH}px)`});

  const gridClasses = classnames('d-flex align-items-center', {
    'justify-content-center': !isMobile,
    'justify-content-end' : isMobile
  });

  const cardSectionClasses = classnames('grid-item-md grid-item-lg-7-10 position-relative', {
    'pt-3 p-0': !isMobile || isTablet,
    'px-0': isMobile
  });

  return (
    <div className={`position-relative ${touchPointClasses}`} style={touchPointStyle}>
      <div className={`py-4 mb-6 ${bgColor}`}>
        <div className='position-absolute' style={{top: '-20px', left: isMobile ? '20px' : '400px'}}>
          <LazyImage
            src={stoneImage}
            width='53'
            height='52'
            title='stone'
            alt='stone'
          />
        </div>
        {isMobile ?
          <div className='position-absolute' style={{bottom: '150px', right: '0'}}>
            <LazyImage
              src={redSmallStone}
              width='56'
              height='115'
              alt="red-stone"
              title="red-stone" />
          </div> : 
          <div className='position-absolute' style={{bottom: '100px', right: '100px'}}>
            <LazyImage
              src={lightRedStone}
              imgClass="d-xl-block d-none"
              width="130"
              height="115"
              alt="light-red-stone"
              title="light-red-stone"
            />
          </div>
        }
        <div style={{height: isMobile ? '500px' : ' 200px'}}>
        </div>
      </div>
      <div className={gridClasses} style={{marginTop: isMobile ? '-550px' : '-250px'}}>
        <Section>
          <div className="position-absolute" style={{bottom: '150px', left: '100px'}}>
            <LazyImage
              imgClass="d-xl-block d-none"
              src={lightYellowStone}
              alt="yellow-stone"
              title="yellow-stone"
              width="76"
              height="63"
            />     
          </div>
          <div className='d-flex flex-wrap-reverse justify-content-center'>
            <div className="d-flex grid-item-md grid-item-lg-3-10 text-center mt-4 p-0">
              <LazyImage
                wrapperClass='mx-auto'
                imgClass="position-relative"
                src={replaceAssetsImgUrl(manageBooking.manage_booking_image)}
                style={{bottom: isMobile || isTablet ? '50px' : '0', zIndex: '10'}}
                width='220'
                height='266'
                title='group of people'
                alt='group of people'
              />
            </div>
            <div className={cardSectionClasses} style={{bottom: isMobile ? '0' : '30px'}}>
              <div className="position-absolute" style={{right: '0px', top: '-40px', zIndex: '10'}}>
                <LazyImage
                  src={partyIcon}
                  width='62'
                  height='63'
                  title='party-popper'
                  alt='party-popper'
                />
              </div>
              <div>
                <ManageCardTouchPoints manageBooking={manageBooking} />
              </div>
            </div>
          </div>
        </Section>
      </div>
    </div>
  );
};

ManageBookingTouchPoints.propTypes = {
  manageBooking: PropTypes.shape({
    manage_booking_image: PropTypes.string.isRequired
  }),
  bgColor: PropTypes.string.isRequired,
  touchPointClasses: PropTypes.string.isRequired,
  touchPointStyle: PropTypes.object
};

export default ManageBookingTouchPoints;